module.exports = __webpack_public_path__ + "media/img/frontend_application/homepage_reward_desktop-888c10084661bffeb21aa1d96a4ee2ac.png";